import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  //Anomalies - Missing Data Tab
  loaderMissingData: false,
  missingData: [] as Record<string, any>[],
  missingMetadata: {} as Record<string, any>,
  isFetchedForMissingData: false,

  //Anomalies - FTD Tab
  loaderFtdData: false,
  zeroPerformanceFtdData: [] as Record<string, any>[],
  zeroPerformanceFtdMetadata: {} as Record<string, any>,
  problematicFtdData: [] as Record<string, any>[],
  problematicFtdMetadata: {} as Record<string, any>,
  isFetchedForFtdData: false,

  //Anomalies - Brand Tab
  loaderAnomaliesBrand: false,
  withoutFtdAndNetRevBrandData: [] as Record<string, any>[],
  withoutFtdAndNetRevBrandMetadata: {} as Record<string, any>,
  playersAndDailyPerformance: [] as Record<string, any>[],
  playersAndDailyPerformanceMetadata: {} as Record<string, any>,
  isFetchedForBrandData: false,

  //Anomalies - Income Tab
  loaderIncomeData: false,
  incomeGapsMTDData: [] as Record<string, any>[],
  incomeGapsMTDMetadata: {} as Record<string, any>,
  decreaseDailyIncomeData: [] as Record<string, any>[],
  decreaseDailyIncomeMetadata: {} as Record<string, any>,
  isFetchedForIncomeData: false,

  //Anomalies - Earning Tab
  loaderEarningData: false,
  dailyEarningGapsData: [] as Record<string, any>[],
  dailyEarningGapsMetadata: {} as Record<string, any>,
  monthlyEarningGapsData: [] as Record<string, any>[],
  monthlyEarningGapsMetadata: {} as Record<string, any>,
  isFetchedForEarningData: false,
};

const bizDevelopmentAnomalies = createSlice({
  name: "bizDevelopmentAnomalies",
  initialState: initialState,
  reducers: {
    setLoaderMissingData: (state, action) => {
      state.loaderMissingData = action.payload;
    },
    setMissingData: (state, action) => {
      state.missingData = action.payload;
    },
    setMissingMetadata: (state, action) => {
      state.missingMetadata = action.payload;
    },
    setIsFetchedForMissingData: (state, action) => {
      state.isFetchedForMissingData = action.payload;
    },
    setLoaderFtdData: (state, action) => {
      state.loaderFtdData = action.payload;
    },
    setZeroPerformanceFtdData: (state, action) => {
      state.zeroPerformanceFtdData = action.payload;
    },
    setZeroPerformanceFtdMetadata: (state, action) => {
      state.zeroPerformanceFtdMetadata = action.payload;
    },
    setProblematicFtdData: (state, action) => {
      state.problematicFtdData = action.payload;
    },
    setProblematicFtdMetadata: (state, action) => {
      state.problematicFtdMetadata = action.payload;
    },
    setIsFetchedForFtdData: (state, action) => {
      state.isFetchedForFtdData = action.payload;
    },
    setLoaderAnomaliesBrand: (state, action) => {
      state.loaderAnomaliesBrand = action.payload;
    },
    setWithoutFtdAndNetRevBrandData: (state, action) => {
      state.withoutFtdAndNetRevBrandData = action.payload;
    },
    setWithoutFtdAndNetRevBrandMetadata: (state, action) => {
      state.withoutFtdAndNetRevBrandMetadata = action.payload;
    },
    setPlayersAndDailyPerformanceData: (state, action) => {
      state.playersAndDailyPerformance = action.payload;
    },
    setPlayersAndDailyPerformanceMetadata: (state, action) => {
      state.playersAndDailyPerformanceMetadata = action.payload;
    },
    setIsFetchedForBrandData: (state, action) => {
      state.isFetchedForBrandData = action.payload;
    },
    setLoaderIncomeData: (state, action) => {
      state.loaderIncomeData = action.payload;
    },
    setIncomeGapsMTDData: (state, action) => {
      state.incomeGapsMTDData = action.payload;
    },
    setIncomeGapsMTDMetadata: (state, action) => {
      state.incomeGapsMTDMetadata = action.payload;
    },
    setDecreaseDailyIncomeData: (state, action) => {
      state.decreaseDailyIncomeData = action.payload;
    },
    setDecreaseDailyIncomeMetadata: (state, action) => {
      state.decreaseDailyIncomeMetadata = action.payload;
    },
    setIsFetchedForIncomeData: (state, action) => {
      state.isFetchedForIncomeData = action.payload;
    },
    setLoaderEarningData: (state, action) => {
      state.loaderEarningData = action.payload;
    },
    setDailyEarningGapsData: (state, action) => {
      state.dailyEarningGapsData = action.payload;
    },
    setDailyEarningGapsMetadata: (state, action) => {
      state.dailyEarningGapsMetadata = action.payload;
    },
    setMonthlyEarningGapsData: (state, action) => {
      state.monthlyEarningGapsData = action.payload;
    },
    setMonthlyEarningGapsMetadata: (state, action) => {
      state.monthlyEarningGapsMetadata = action.payload;
    },
    setIsFetchedForEarningData: (state, action) => {
      state.isFetchedForEarningData = action.payload;
    },

    resetbizDevelopmentAnomaliesState: () => initialState,
  },
});

export const {
  //Anomalies - Missing Data Tab
  setLoaderMissingData,
  setMissingData,
  setMissingMetadata,
  setIsFetchedForMissingData,

  //Anomalies - FTD Tab
  setLoaderFtdData,
  setZeroPerformanceFtdData,
  setZeroPerformanceFtdMetadata,
  setProblematicFtdData,
  setProblematicFtdMetadata,
  setIsFetchedForFtdData,

  //Anomalies - Brand Tab
  setLoaderAnomaliesBrand,
  setWithoutFtdAndNetRevBrandData,
  setWithoutFtdAndNetRevBrandMetadata,
  setPlayersAndDailyPerformanceData,
  setPlayersAndDailyPerformanceMetadata,
  setIsFetchedForBrandData,

  //Anomalies - Income Tab
  setLoaderIncomeData,
  setIncomeGapsMTDData,
  setIncomeGapsMTDMetadata,
  setDecreaseDailyIncomeData,
  setDecreaseDailyIncomeMetadata,
  setIsFetchedForIncomeData,

  //Anomalies - Earning Tab
  setLoaderEarningData,
  setDailyEarningGapsData,
  setDailyEarningGapsMetadata,
  setMonthlyEarningGapsData,
  setMonthlyEarningGapsMetadata,
  setIsFetchedForEarningData,

  resetbizDevelopmentAnomaliesState,
} = bizDevelopmentAnomalies.actions;
export default bizDevelopmentAnomalies.reducer;
